<template>
  <div class="about">
    <div>
      基础金价：{{basicsPrice}}元/克&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      基础银价：{{silverPrice}}元/克
    </div>
    <div class="custom-wrapper">
      <div class="input-wrapper">
        自定义金价: <Input v-model="customGold" placeholder="输入自定义金价"  class="input" />
        自定义银价: <Input v-model="customSilver" placeholder="输入自定义银价" class="input"/>
        <Button type="primary" @click="updataCustomPrice">更新</Button>

      </div>
    </div>

    <Table :columns="columns" :data="list"></Table>

    <div class="add">
      <Button type="primary" @click="createModal=true">增加模板</Button>
    </div>

    <div>
     
      <div class="tip">
        tip:
        <br/>
        基础金价=上海黄金交易所黄金牌价（以“x”表示）, 基础银价（以“y”表示），自定义金价（以“z”表示），自定义银价（以“w”表示）。金银类产品公式应用 | 分隔，列如:(x+20)*1.2|(y+20)*1.2，价格模板可以根据自行设定公式，自定义一克金价乘以产品克数，实行批量计算。例如：黄金吊坠实际克数20克。金价是黄金牌价x+156工费。利润30%。那么价格模板公式：(x+156)*1.3。注：系统默认克数，不用填写。
      </div>
     
    </div>
    <Modal v-model="updateModal" title="更新模板" @on-ok="update">
      <Input v-model="updateName" placeholder="输入名称" style="margin-bottom: 5px"/>
      <Input v-model="updateformula" placeholder="输入模板"/>
    </Modal>
    <Modal v-model="createModal" title="创建模板" @on-ok="create">
      <Input v-model="createName" placeholder="输入名称" style="margin-bottom: 5px"/>
      <Input v-model="createformula" placeholder="输入模板"/>
    </Modal>

     <Spin size="large" fix v-if="spinShow">
       <!-- <div>正在更新中,请稍等~</div> -->
     </Spin>
  </div>
</template>

<script>
import { Button, Table, Modal, Input, Spin} from "iview";
import { getPrice } from "@/api/goldPrice";
import {
  getTemplate,
  deleteTemplate,
  updateTemplate,
  createTemplate,
  getParameter,
  createParameter,
  updateParameter,
  deleteParameter,
  allUpdate
} from "@/api/templateReq";
export default {
  name: "about",

  components: {
    Button,
    Table,
    Modal,
    Input,
    Spin
  },

  data() {
    return {
      columns: [
        {
          title: "模板Id",
          key: "goods_price_template_id"
        },
        {
          title: "模板名称",
          key: "name"
        },
        {
          title: "模板公式",
          key: "formula"
        },
        {
          title: "操作",
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                Button,
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.updateTem(params.row);
                    }
                  }
                },
                "更新"
              ),
              h(
                Button,
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.removeTem(params.row.goods_price_template_id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      list: [],
      updateModal: false,
      updateId: null,
      updateName: "",
      updateformula: "",
      createModal: false,
      createName: "",
      createformula: "",
      basicsPrice: '',
      silverPrice: '',
      customGold: '',
      customSilver: '',
      customGoldType: '',
      customSilverType: '',
      spinShow: false
    };
  },

  created() {
    this.getTemplateList();
    getParameter().then(res=>{
      if(res.data.data.length===0) {
        this.customGoldType = 'create';
        this.customSilverType = 'create';
      }else{
        res.data.data.forEach(element => {
          if(element.key==='z'){
            this.customGoldType = element.id;
            this.customGold = element.value;
          }
          if(element.key==='w'){
            this.customSilverType = element.id;
            this.customSilver = element.value;
          }
        });
      }
      
    })
  },

  activated() {
     getPrice('JO_9754').then(res => {
      this.silverPrice = (res.data.data['JO_9754'].q63 / 1000).toFixed(2); 
      this.basicsPrice = res.data.data.base_price;
    });


  },

  methods: {
    getTemplateList() {
      getTemplate().then(res => {
        this.list = res.data.data;
      });
    },
    updateTem(row) {
      this.updateId = row.goods_price_template_id;
      this.updateName = row.name;
      this.updateformula = row.formula;
      this.updateModal = true;
    },
    removeTem(id) {
      this.$Modal.confirm({
        title: "是否确认删除？",
        onOk: () => {
          deleteTemplate(id).then(() => {
            this.$Message.success("删除成功");
            this.getTemplateList()
          });
        }
      });
    },
    update() {
      updateTemplate({
        goods_price_template_id: this.updateId,
        formula: this.updateformula,
        name: this.updateName
      }).then(res => {
        this.getTemplateList() 
        this.$Message.success("更新成功");
      });
    },
    create() {
      createTemplate(this.createformula, this.createName).then(() => {
        this.$Message.success("创建成功");
        this.getTemplateList()
      });
    },

    //更新自定义价格
    updataCustomPrice(){
      if(this.customGold==='' || this.customSilver===''){
        this.$Message.error('请填写完整自定义金价及银价');
        return
      }
      this.spinShow = true;
      if(this.customGoldType === 'create' && this.customSilverType === 'create'){
        let createGold = createParameter('自定义金价', 'z', this.customGold);
        let createSilver = createParameter('自定义银价', 'w', this.customSilver);
        Promise.all([createGold, createSilver]).then( ()=> {
          this.allUpdatePrice()
        }).catch(()=>{
          this.$Message.error('更新失败，请重试');
          this.spinShow = false;
        });
      }else {
        let updateGold = updateParameter(this.customGoldType, '自定义金价', 'z', this.customGold);
        let updateSilver = updateParameter(this.customSilverType, '自定义银价', 'w', this.customSilver);
        Promise.all([updateGold, updateSilver]).then( ()=> {
          this.allUpdatePrice()  
        }).catch(()=>{
          this.$Message.error('更新失败，请重试');
          this.spinShow = false;
        });
      }
    },

    //一键更新
    allUpdatePrice(){
      let firstArr = this.list.filter(ele=>{
        return ele.formula.indexOf('z')>-1 || ele.formula.indexOf('w')>-1
      })
      if(firstArr.length===0){
        this.$Message.error('没有对应公式');
        this.spinShow = false;
        return
      }
      let paramsArr = [];
      var z = Number(this.customGold)
      var w = Number(this.customSilver);
      firstArr.forEach(ele => {
        if(ele.formula.indexOf('z')>-1 && ele.formula.indexOf('w')>-1){   
          let temArr = ele.formula.split("|");
          let gold = eval(temArr[0]).toFixed(2);
          let silver = eval(temArr[1]).toFixed(2);
          paramsArr.push({
            "goods_price_template_id": ele.goods_price_template_id,
            "gold_multiple": gold,
            "silver_multiple": silver
          })
        }
        if(ele.formula.indexOf('z')>-1 && ele.formula.indexOf('w')===-1){
          let gold = eval(ele.formula).toFixed(2);
          paramsArr.push({
            "goods_price_template_id": ele.goods_price_template_id,
            "gold_multiple": gold,
            "silver_multiple": 0
          })
        }
        if(ele.formula.indexOf('z')===-1 && ele.formula.indexOf('w')>-1){
          let silver = eval(ele.formula).toFixed(2);
          paramsArr.push({
            "goods_price_template_id": ele.goods_price_template_id,
            "gold_multiple": 0,
            "silver_multiple": silver
          })
        }
      });
      console.log(paramsArr);
      allUpdate(paramsArr).then(res=>{
        if(res.data.code===200){
          this.$Message.success("更新成功");
          this.spinShow = false;
        }else{
          this.$Message.error('更新失败，请重试');
          this.spinShow = false;
        }
      })
      
    }
  }
};
</script>

<style lang="less">
.about{
  padding: 10px 20px;
  position: relative;
}
.custom-wrapper{
  margin-bottom: 20px;
  margin-top: 20px;

  .input-wrapper{
    height: 50px;
    line-height: 50px;
  }
  .input{
    width: 30%;
    margin-right:60px
  }
}
.add {
  margin-top: 10px;
  text-align: right;
  padding-right: 10px;
}
.tip{
  color: #b52333;
}
</style>
